// extracted by mini-css-extract-plugin
export default {"Header":"Header_DwUl_"};